module.exports = __webpack_public_path__ + "img/r1.06e6d955.jpg";